import { cssToken } from '@cp/ui/utils';

export const name = 'Footer';

export const CssTokens = {
  itemHeaderOffset: cssToken(name, ['item', 'header', 'offset']),
};
